import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { LeafIcon, HeartPulseIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const benefits = [{
  icon: LeafIcon,
  title: '100% natürliche Zutaten',
  description: 'Nur ausgewählte, natürliche Inhaltsstoffe – ohne Chemie, ohne Kompromisse.'
}, {
  icon: HeartPulseIcon,
  title: 'Präbiotika für die Darmflora',
  description: 'Unterstützt aktiv eine gesunde Verdauung und stärkt das Immunsystem deines Hundes.'
}, {
  icon: ShieldCheckIcon,
  title: 'Keine künstlichen Zusatzstoffe',
  description: 'Frei von Konservierungsstoffen, Farbstoffen und künstlichen Aromen.'
}, {
  icon: SparklesIcon,
  title: 'Einfach übers Futter streuen',
  description: 'Kein Aufwand, kein Stress – einfach einen Löffel über das gewohnte Futter geben.'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BenefitsSection() {
  return <section className="w-full py-16" style={{
    backgroundColor: 'white'
  }} data-id="element-12">
      <div className="max-w-3xl mx-auto px-4" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-14">
          <h3 className="font-handwritten text-3xl md:text-4xl mb-3" style={{
          color: 'var(--color-green)'
        }} data-id="element-15">
            Was dieses Topping so besonders macht
          </h3>
          <p className="text-base" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-16">
            Die Gründe, warum ich es jedem Hundebesitzer empfehle
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-17">
          {benefits.map(benefit => <motion.div key={benefit.title} variants={itemVariants} className="rounded-xl p-6 border" style={{
          borderColor: 'var(--color-border)',
          backgroundColor: 'var(--color-cream)'
        }} data-id="element-18">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'var(--color-green-light)'
          }} data-id="element-19">
                <benefit.icon className="w-6 h-6" style={{
              color: 'var(--color-green)'
            }} data-id="element-20" />
              </div>
              <h4 className="font-semibold text-lg mb-2" style={{
            color: 'var(--color-text)'
          }} data-id="element-21">
                {benefit.title}
              </h4>
              <p className="text-sm leading-relaxed" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-22">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-23">
          <CTAButton label="Jetzt für meinen Hund bestellen" position="ingredients_cta" data-id="element-24" />
        </motion.div>
      </div>
    </section>;
}